// @flow

import type { Thread } from '../types';

export const FETCH_THREADS: string = 'FETCH_THREADS';
export const FETCH_THREADS_SUCCESS: string = 'FETCH_THREADS_SUCCESS';
export const FETCH_THREADS_FAILURE: string = 'FETCH_THREADS_FAILURE';
export const FILTER_THREADS_SEARCH: string = 'FILTER_THREADS_SEARCH';
export const FILTER_THREADS_SEARCH_THROTTLE: string =
  'FILTER_THREADS_SEARCH_THROTTLE';
export const FILTER_THREADS_UNREAD: string = 'FILTER_THREADS_UNREAD';
export const FILTER_THREADS_TRACKED: string = 'FILTER_THREADS_TRACKED';
export const FILTER_THREADS_SUCCESS: string = 'FILTER_THREADS_SUCCESS';
export const FILTER_THREADS_FAILURE: string = 'FILTER_THREADS_FAILURE';
export const TRACK_THREAD: string = 'TRACK_THREAD';
export const TRACK_THREAD_SUCCESS: string = 'TRACK_THREAD_SUCCESS';
export const TRACK_THREAD_FAILURE: string = 'TRACK_THREAD_FAILURE';
export const READ_THREAD: string = 'READ_THREAD';
export const READ_THREAD_SUCCESS: string = 'READ_THREAD_SUCCESS';
export const READ_THREAD_FAILURE: string = 'READ_THREAD_FAILURE';
export const CREATE_THREAD: string = 'CREATE_THREAD';
export const CREATE_THREAD_SUCCESS: string = 'CREATE_THREAD_SUCCESS';

export const fetchThreads = () => ({
  type: FETCH_THREADS,
});

export const filterThreadsSearch = (search: string) => ({
  type: FILTER_THREADS_SEARCH,
  value: search,
});

export const filterThreadsUnread = (unread: boolean) => ({
  type: FILTER_THREADS_UNREAD,
  value: unread,
});

export const filterThreadsTracked = (tracked: boolean) => ({
  type: FILTER_THREADS_TRACKED,
  value: tracked,
});

export const trackThread = (thread: string, value: boolean) => ({
  type: TRACK_THREAD,
  thread,
  value,
});

export const readThread = (thread: string, upToIndex: number) => ({
  type: READ_THREAD,
  thread,
  upToIndex,
});

export const createThread = (thread: Thread) => ({
  type: CREATE_THREAD,
  thread,
});



// WEBPACK FOOTER //
// ./src/modules/messaging/actions/threads.js